/**
 * Cluster D — #8: cart clears on region (country) switch.
 *
 * Exposes a tiny global helper that assets/localization-form.js calls from
 * its onItemClick handler, BEFORE the localization form submits/reloads, so
 * switching COUNTRY (not language) silently empties the cart. See the call
 * site in localization-form.js for the country-vs-language guard (keyed off
 * the form's hidden input name: `country_code` vs `locale_code`), which
 * covers every localization-form instance site-wide (header, header drawer,
 * footer, announcement bar) since they all render the same
 * snippets/country-localization.liquid / language-localization.liquid.
 *
 * Best-effort + silent: if the request fails (offline, etc.) we still let
 * the region switch proceed rather than blocking navigation on it.
 */
window.pfannerRegionCartClear = function pfannerRegionCartClear() {
  return fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).catch(() => {
    /* silent — best-effort clear, must not block the region switch */
  });
};
